import React,
{
    useEffect,
    useState,
} from 'react';
import {
    House,
    Search,
    Heart,
    Bell,
    BookHeart,
} from 'lucide-react';
import {
    Outlet,
    useNavigate,
    useLocation,
} from 'react-router-dom';
import { AccessModel } from '../components';

const MainMenuLayout: React.FC = () => {

    const location = useLocation();

    const [premium] = useState(true);
    const [accessModel, setAccessModel] = useState(false);

    const getLastPath = () => {
        const pathSegment = location.pathname.split('/');
        return pathSegment[pathSegment.length - 1] || '';
    }
    const [active, setActive] = useState(getLastPath());
    const navigate = useNavigate();

    useEffect(() => {
        setActive(getLastPath());
    }, [location.pathname]);

    const handleActive = (item: string) => {

        if ((!premium && (item === 'search'))) {
            setAccessModel(true);
        } else if (item === 'home') {
            navigate('');
            setActive(item);
        }
        else {
            navigate(item);
            setActive(item);
        }

        // if (item !== 'home') {
        //     navigate(item);
        // } 
        // else {
        //     navigate('');
        // }
    }

    const menuItems = [
        { id: 'home', label: 'Home', Icon: House },
        { id: 'search', label: 'Search', Icon: Search },
        { id: 'interested', label: 'Interested', Icon: BookHeart },
        { id: 'favourite', label: 'Favourites', Icon: Heart },
        { id: 'notifications', label: 'Notifications', Icon: Bell },
    ];

    return (
        <div className='flex flex-col w-full md:w-full lg:w-3/4 gap-2 mt-2'>
            <nav className='flex justify-between w-full text-md font-medium font-outfit'>
                {
                    menuItems.map(({ id, label, Icon }) => (
                        <button
                            key={id}
                            onClick={() => handleActive(id)}
                            className={`flex gap-2 items-center justify-center w-full py-2 border-b-4 ${active === id ? 'border-primary text-primary' : 'border-grayColor text-textColor'
                                }`}>
                            <Icon size={20}
                                className={`${active === id ? 'text-primary' : 'text-textLight'}`} />

                            <span className="hidden md:inline">{label}</span>
                        </button>
                    ))
                }
            </nav>
            <Outlet />

            {accessModel && (
                <AccessModel
                    onClose={() => setAccessModel(false)}
                />
            )}
        </div>
    )
}

export default MainMenuLayout;